<agr-form-dialog [formGroup]="formGroup" (confirm)="save()" (cancel)="cancel()" [data]="data">
  <div class="flex--column spacing--margin-top">
    <mat-form-field class="flex__child--auto" *ngIf="barns$ | async as barns">
      <mat-label>{{ 'barn' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'barn' | translate }}"
        formControlName="barn"
        data-test="discount-item__barn"
      >
        <mat-option *ngFor="let barn of barns" [value]="barn">{{ barn.name }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'discount-applicabilityType' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'discount-applicabilityType' | translate }}"
        formControlName="applicabilityType"
        data-test="discount-item__applicabilityType"
        (selectionChange)="applicabilityTypeChanged($event)"
      >
        <mat-option
          *ngFor="let applicabilityType of applicabilityTypes"
          [value]="applicabilityType"
        >
          {{
            'discount-item.applicabilityType-' + applicabilityType.toString().toLowerCase()
              | translate
          }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'discount-label' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        placeholder="{{ 'discount-label' | translate }}"
        formControlName="label"
        data-test="discount-item__label"
      >
        <mat-option *ngFor="let label of labels" [value]="label">
          {{ 'discount-item.labelType-' + label.toString().toLowerCase() | translate }}</mat-option
        >
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'discount-amount' | translate }}</mat-label>
      <input
        matInput
        agrNumber
        [step]="0.01"
        [enableStepArrows]="false"
        formControlName="amount"
        placeholder="{{ 'discount-amount' | translate }}"
        data-test="discount-item__amount"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
      <mat-label>{{ 'invoice-date' | translate }}</mat-label>
      <input
        matInput
        formControlName="invoiceDate"
        [matDatepicker]="invoiceDatePicker"
        placeholder="{{ 'invoice-date' | translate }}"
        data-test="discount-item__invoice-date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="invoiceDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #invoiceDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
      <mat-label>{{ 'invoice-number' | translate }}</mat-label>
      <input
        matInput
        formControlName="invoiceNumber"
        placeholder="{{ 'invoice-number' | translate }}"
        data-test="discount-item__invoice-number"
      />
    </mat-form-field>

    <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
      <mat-label>{{ 'vat-percentage' | translate }}</mat-label>
      <span matTextSuffix>%</span>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="vatPercentage"
        data-test="discount-item__vatPercentage"
      >
        <mat-option [value]="null"></mat-option>
        <mat-option *ngFor="let vatPercentage of vatPercentages" [value]="vatPercentage">
          {{ vatPercentage }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field
      class="flex__child--auto"
      *ngIf="formGroup.controls.label.value === discountLabelEnum.Other"
    >
      <mat-label>{{ 'discount-description' | translate }}</mat-label>
      <input
        matInput
        formControlName="description"
        placeholder="{{ 'discount-description' | translate }}"
        data-test="discount-item__description"
      />
    </mat-form-field>
  </div>
</agr-form-dialog>
